import axios from 'axios'
import { serverBaseUrl } from './environment'

axios.defaults.baseURL = serverBaseUrl + '/api/'

const axiosInstance = axios.create()

const token = localStorage.getItem('cpd-tk')
if (token) {
  axiosInstance.defaults.headers.common.authorization = `Bearer ${token}`
}

export function setupInterceptors (router, store) {
  axiosInstance.interceptors.response.use(res => res, error => {
    if (error.response && error.response.status === 401) {
      router.replace(`/start?redirect=${window.location.pathname + window.location.search}`)
    }
    if (error.message === 'Network Error') {
      store.dispatch('showSnackbar', { color: 'error', text: 'We\'re having trouble connecting to the Pathfinder. Please check your internet connection, or come back later.' })
    }
    return Promise.reject(error)
  })
}

export { axiosInstance, serverBaseUrl }
